.tiptap * {
  font-family: "Inter-Regular", sans-serif;
  font-optical-sizing: auto;
}

.tiptap.ProseMirror {
  height: 100%;
  overflow: hidden;
}

.ProseMirror:focus {
  outline: none;
}

.tiptap p {
  font-size: 1em;
}
.tiptap strong {
  font-family: "Inter-Bold";
  font-weight: bold;
}
.tiptap em {
  font-family: "Inter-Italic";
  font-style: italic !important;
}

.tiptap em strong,
.tiptap strong em {
  font-family: "Inter-SemiBoldItalic";
}

.tiptap *,
.tiptap *::before,
.tiptap *::after {
  box-sizing: border-box;
}
/*
  2. Remove default margin
*/
.tiptap * {
  margin: 0;
}
/*
  Typographic tweaks!
  3. Add accessible line-height
  4. Improve text rendering
*/
.tiptap {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}
/*
  5. Improve media defaults
*/
.tiptap img,
.tiptap picture,
.tiptap video,
.tiptap canvas,
.tiptap svg {
  display: block;
  max-width: 100%;
}
/*
  6. Remove built-in form typography styles
*/
.tiptap input,
.tiptap button,
.tiptap textarea,
.tiptap select {
  font: inherit;
}
/*
  7. Avoid text overflows
*/
.tiptap p,
.tiptap h1,
.tiptap h2,
.tiptap h3,
.tiptap h4,
.tiptap h5,
.tiptap h6 {
  overflow-wrap: break-word;
}
